import classnames from 'classnames';

import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';

import styles from './productToCompare.module.scss';

export const ProductToCompareSkeleton = () => (
  <div className={styles.container}>
    <div className={styles.link}>
      <Skeleton className={classnames(styles.image, styles.imageSkeleton)} />
      <div className={styles.mainInfo}>
        <div className={styles.tags} />
        <Skeleton className={styles.title} />
      </div>
    </div>

    <div className={styles.addToCart}>
      <Skeleton className={styles.addToCartButtonSkeleton} theme="dark" />
    </div>

    <div className={classnames(styles.rowHeader, styles.rowHeaderSkeleton)} />
    <div className={classnames(styles.rowContent, styles.price)}>
      <Skeleton className={styles.priceSkeleton} />
    </div>

    <div className={classnames(styles.rowHeader, styles.rowHeaderSkeleton)} />
    <div className={styles.rowContent}>
      <Skeleton
        width={190}
        className={classnames(
          styles.rating,
          styles.rowContent,
          styles.rowContentSkeleton,
        )}
      />
    </div>

    <div className={classnames(styles.rowHeader, styles.rowHeaderSkeleton)} />
    <div className={styles.rowContent}>
      <Skeleton
        width={120}
        className={classnames(
          styles.rating,
          styles.rowContent,
          styles.rowContentSkeleton,
        )}
      />
    </div>

    <div className={classnames(styles.rowHeader, styles.rowHeaderSkeleton)} />
    <div className={styles.rowContent}>
      <Skeleton
        width={80}
        className={classnames(
          styles.rating,
          styles.rowContent,
          styles.rowContentSkeleton,
        )}
      />
    </div>

    <div className={classnames(styles.rowHeader, styles.rowHeaderSkeleton)} />
    <div className={styles.rowContent}>
      <Skeleton
        width={170}
        className={classnames(
          styles.rating,
          styles.rowContent,
          styles.rowContentSkeleton,
        )}
      />
    </div>
  </div>
);

ProductToCompareSkeleton.displayName = 'ProductToCompareSkeleton';
